/**
 * Box 4 capture helpers. The live map is a wide rectangle; a 400×400 screenshot
 * would change Esri's extent. The export sends PNG bytes so the server does not
 * have to re-sign the stored blob.
 */

export function ics201SketchScreenshotSize(mapView: {
  width: number;
  height: number;
}): { width: number; height: number } | undefined {
  const width = Math.round(mapView.width);
  const height = Math.round(mapView.height);
  if (width < 1 || height < 1) return undefined;
  return { width, height };
}

export async function fileFromSavedSketch(
  mapSketchUrl: string,
  getSignedUrl: (blobUrl: string) => Promise<string>
): Promise<File | undefined> {
  const signedUrl = await getSignedUrl(mapSketchUrl);
  const response = await fetch(signedUrl);
  if (!response.ok) return undefined;
  const blob = await response.blob();
  return new File([blob], 'mapSketch.png', { type: blob.type || 'image/png' });
}

export async function resolveIcs201MapSketchFile(options: {
  captureSketchFile?: () => Promise<File | undefined> | undefined;
  mapSketchUrl?: string;
  getSignedUrl: (blobUrl: string) => Promise<string>;
}): Promise<File | null> {
  const live = await options.captureSketchFile?.();
  if (live) return live;
  if (!options.mapSketchUrl) return null;
  try {
    return (
      (await fileFromSavedSketch(options.mapSketchUrl, options.getSignedUrl)) ??
      null
    );
  } catch (error) {
    console.error('Could not download the saved ICS-201 map sketch:', error);
    return null;
  }
}
